module.exports = __webpack_public_path__ + "fonts/be-vietnam-pro-v8-latin-700.99ca0fd.woff";